import { render, staticRenderFns } from "./QuickTaskDialog.vue?vue&type=template&id=cb54dbe2&scoped=true"
import script from "./QuickTaskDialog.vue?vue&type=script&lang=js"
export * from "./QuickTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./QuickTaskDialog.vue?vue&type=style&index=0&id=cb54dbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb54dbe2",
  null
  
)

export default component.exports